module.exports = __webpack_public_path__ + "6853a0092ebae1ca26ed73781ae44427.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-5.png
// module id = 1805
// module chunks = 0